module.exports = __webpack_public_path__ + "static/media/Rangeval.48b0eb01.svg";